import InlineItemsList from "@entrilia/shared/components/InlineItemsList";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import { distinct, stringComparerBy } from "@entrilia/shared/utilities/arrayHelper";
import type { DataCollectionRequestTemplateVersion } from "../../../../api/types/dataCollectionTypes";
import DataRequestSetupPageContext from "./DataRequestSetupPageContext";

export const CategoriesCell = ({ row }: { row: DataCollectionRequestTemplateVersion }) => {
  const { categories } = useDefinedContext(DataRequestSetupPageContext);

  const allCategories = distinct([...row.contactCategories, ...row.internalUserPermissionCategories]).map((id) => ({
    id,
    name: categories.find((c) => c.id === id)?.name ?? id,
  }));

  return allCategories.length === 0 ? (
    "-"
  ) : (
    <InlineItemsList
      displayCount={2}
      items={allCategories}
      propGetter={(x) => x.name}
      sortComparer={stringComparerBy((x) => x)}
    />
  );
};
